














import inputMixin from 'library/mixins/input-mixin'

export default

	mixins: [inputMixin]

	props:
		options:
			type: Array
			default: -> []

	# Make options rendered to preserve reusability of component
	computed: renderedOptions: -> @options.map @mapOption

	methods:
		mapOption: (option) ->
			if 'object' == typeof option then option
			else { label: option, value: option}

